// extracted by mini-css-extract-plugin
module.exports = {"spinner-section":"loading-spinner_spinner-section__ce5HM","loading-spinner":"loading-spinner_loading-spinner__3mGzX"};